module.exports = __webpack_public_path__ + "static/media/NJ0151-53M.fa31600b.png";